/** @prettier */
import React from "react";
import "./ProgressBar.css";

const percentToString = (percent: number) =>
    `${Math.min(100, Math.max(0, Math.round(100 * percent)))}%`;

const ProgressBar = ({ percent }: { percent: number }) => (
    <div className="progress-bar">
        <div
            className="progress-bar-done"
            style={{ minWidth: percentToString(percent) }}
        ></div>
        <div className="progress-bar-todo"></div>
    </div>
);
export default ProgressBar;
